import React from 'react';
import './MenuPanel.css';
import { usePanels } from './App';

function MenuPanel() {
  const { showPanel, hidePanel, togglePanel, swapPanel, isPanelActive } = usePanels();

  const sections = [
    { id: 'home', label: 'Home', swap: { showId: 'intro', panelName: 'leftPanel' } },
    { id: 'about', label: 'Is AI ___?', swap: { showId: 'about', panelName: 'rightPanel' } },
    { id: 'services', label: 'How we help', swap: { showId: 'services', panelName: 'rightPanel' } },
    { id: 'projects', label: 'Insights & Demos', swap: { showId: 'projects', panelName: 'rightPanel' } },
    { id: 'contact', label: '❤️ Tetris ❤️', swap: { showId: 'tetris', panelName: 'rightPanel' } }
  ];

  return (
    <div id="menuPanel" className="Panel Panel-menu">
      <nav className="menu-nav">
        <ul className="menu-list">
          {sections.map((section, idx) => (
            <li
              key={section.id}
              className="menu-item menu-item-animate"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <a
                href={`#${section.id}`}
                className="menu-link"
                onClick={e => {
                  e.preventDefault();
                  swapPanel(section.swap.showId, section.swap.panelName);
                }}
              >
                {section.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default MenuPanel; 